import { mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

import ArticlesStateMixins from '@/modules/content/components/ContentPage/mixins/ArticlesStateMixins';

export default {
  name: 'ArticlesActionsMixins',
  mixins: [
    ArticlesStateMixins,
  ],
  computed: {
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN,
      campaignTypes.GET_IS_READ_ONLY,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_ARTICLE_BY_ID,
    ]),
    canUpdateApprovalState() {
      return this.GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN;
    },
  },
  methods: {
    canPublishArticles({ ids } = {}) {
      if (this.GET_IS_READ_ONLY()) return false;
      return ids.some((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return article?.matchingHealth !== 'LOW'
        && ['DRAFT', 'PAUSED'].includes(article?.state);
      });
    },
    canPauseArticles({ ids } = {}) {
      if (this.GET_IS_READ_ONLY()) return false;
      return ids.some((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return ['PUBLISHED', 'SCHEDULED', 'APPROVAL'].includes(article?.state);
      });
    },
    canScheduleArticles({ ids } = {}) {
      if (this.GET_IS_READ_ONLY()) return false;
      return ids.some((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return article?.matchingHealth !== 'LOW';
      });
    },
    canDeleteArticles({ ids }) {
      if (this.GET_IS_READ_ONLY()) return false;
      return ids.some((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return ['DRAFT', 'FAILED'].includes(article?.state);
      });
    },
    canChangeArticlesLanguage({ ids }) {
      if (this.GET_IS_READ_ONLY()) return false;
      return ids.some((id) => {
        const article = this.GET_ARTICLE_BY_ID(id);
        return ['DRAFT', 'PAUSED'].includes(article?.state);
      });
    },
    canChangeApprovalState({ ids } = {}) {
      if (this.GET_IS_READ_ONLY() && !this.canUpdateApprovalState) return false;
      return ids.some((id) => this.GET_ARTICLE_BY_ID(id)?.state === 'APPROVAL');
    },
  },
};
